module.exports = __webpack_public_path__ + "static/media/manguera-gris.12c8a9cd.svg";